var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyMessageIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 264,
    height: 249,
    viewBox: "0 0 264 249",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.472 22.2766C149.638 20.3936 173.72 -9.60588 194.362 3.14743C215.269 16.065 197.321 52.8252 209.526 74.2082C221.665 95.4764 257.451 98.9883 262.726 122.921C267.777 145.836 246.937 166.257 234.146 185.903C221.924 204.674 209.322 223.858 189.851 234.852C170.475 245.793 147.126 252.313 125.472 247.265C104.8 242.445 94.8637 218.739 76.3178 208.383C57.342 197.787 30.6029 202.562 16.2015 186.249C1.59976 169.709 -0.54814 144.975 0.871371 122.921C2.24828 101.529 13.5569 82.8131 24.0605 64.1486C34.6496 45.3322 42.5817 21.6436 62.4925 13.4227C82.4367 5.18788 103.971 23.9519 125.472 22.2766Z",
    fill: "#ECF4FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.9415 97.3008L138.886 66.7351L179.62 103.954L92.9415 97.3008Z",
    fill: "#183560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.616 103.96L92.9375 97.3066L88.2523 158.346L174.931 164.999L179.616 103.96Z",
    fill: "#183560",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2523 158.346L133.938 131.157L92.9375 97.3066L88.2523 158.346Z",
    fill: "#183560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2523 158.346L133.938 131.157L92.9375 97.3066L88.2523 158.346Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.935 164.995L133.942 131.153L179.62 103.955L174.935 164.995Z",
    fill: "#183560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.935 164.995L133.942 131.153L179.62 103.955L174.935 164.995Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.943 131.155L123.933 122.884L88.2571 158.344L174.935 164.997L145.097 124.508L133.943 131.155Z",
    fill: "#183560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.943 131.155L123.933 122.884L88.2571 158.344L174.935 164.997L145.097 124.508L133.943 131.155Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9375 97.3066L134.551 123.174L179.616 103.96L133.938 131.157L92.9375 97.3066Z",
    fill: "#BCBEC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.712 83.3761L169.632 110.474L133.944 131.158L133.945 131.142L133.944 131.158L101.83 105.27L103.91 78.1719L171.712 83.3761Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.428 95.4877C162.38 96.1107 161.833 96.5798 161.21 96.532L112.26 92.7748C111.637 92.727 111.168 92.1798 111.216 91.5569C111.264 90.934 111.811 90.4648 112.434 90.5126L161.384 94.2698C162.015 94.3182 162.476 94.8648 162.428 95.4877Z",
    fill: "#C9D9F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.889 102.593C161.841 103.216 161.294 103.685 160.671 103.637L111.721 99.8803C111.098 99.8325 110.629 99.2853 110.677 98.6624C110.725 98.0394 111.272 97.5703 111.895 97.6181L160.844 101.375C161.476 101.424 161.937 101.97 161.889 102.593Z",
    fill: "#C9D9F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.336 109.701C161.288 110.324 160.741 110.793 160.118 110.745L111.168 106.988C110.545 106.94 110.076 106.393 110.124 105.77C110.172 105.147 110.719 104.678 111.342 104.725L160.292 108.483C160.922 108.539 161.384 109.078 161.336 109.701Z",
    fill: "#C9D9F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5 73.9474C76.5 76.9429 78.9281 79.371 81.9236 79.371H103.435C106.43 79.371 108.858 76.9429 108.858 73.9474V62.4236C108.858 59.4281 106.43 57 103.435 57H81.9236C78.9281 57 76.5 59.4281 76.5 62.4236V73.9474Z",
    fill: "#00B2AD",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M90.7123 61.5256C90.937 63.2015 90.0784 65.1268 88.8073 66.1052C87.1238 67.4055 84.5749 67.7401 82.4822 67.3424C79.9434 66.8563 77.9748 65.3856 77.9983 62.867C78.0419 58.704 81.7578 58.5493 85.2792 58.502C86.9728 58.4799 89.2299 58.6188 90.2126 60.1369C90.4842 60.5566 90.6485 61.0301 90.7123 61.5256Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2671 75.9094C98.2224 74.6122 101.419 71.7235 102.357 67.5127C102.87 65.2195 102.838 62.7845 101.932 60.5905C101.405 59.318 100.702 58.1448 99.9542 57H103.344C106.33 57 108.75 59.4421 108.75 62.4548V74.0451C108.75 77.0578 106.33 79.4999 103.344 79.4999H81.906C78.9202 79.4999 76.5 77.0578 76.5 74.0451V71.1032C80.3323 76.4765 88.2815 77.8695 94.2671 75.9094Z",
    fill: "#00B2AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.434 79.3711L104.456 84.1286L97.2949 79.3711H103.434Z",
    fill: "#5859A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.434 79.3711L104.456 84.1286L97.2949 79.3711H103.434Z",
    fill: "#00B2AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5605 68.1844C97.5605 68.8962 98.1385 69.4742 98.8504 69.4742C99.5622 69.4742 100.14 68.8962 100.14 68.1844C100.14 67.4725 99.5622 66.8945 98.8504 66.8945C98.1385 66.8945 97.5605 67.4725 97.5605 68.1844Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3887 68.1844C91.3887 68.8962 91.9666 69.4742 92.6785 69.4742C93.3904 69.4742 93.9683 68.8962 93.9683 68.1844C93.9683 67.4725 93.3904 66.8945 92.6785 66.8945C91.9666 66.8945 91.3887 67.4725 91.3887 68.1844Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.209 68.1844C85.209 68.8962 85.7869 69.4742 86.4988 69.4742C87.2107 69.4742 87.7886 68.8962 87.7886 68.1844C87.7886 67.4725 87.2107 66.8945 86.4988 66.8945C85.7869 66.8945 85.209 67.4725 85.209 68.1844Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyMessageIcon);
export default __webpack_public_path__ + "static/media/empty-message-icon.a086d3224251bc40967e94ed7d91b546.svg";
export { ForwardRef as ReactComponent };